module.exports = __webpack_public_path__ + "static/media/psm_question.d5bf8ab3.mp3";